module.exports = __webpack_public_path__ + "img/right_arrow_pink_icon.408e9fe6.svg";